import React from 'react';
import { hexForColorInput, normalizeHexColor } from '../../utils/hubupHexColor';

export default function HexColorField({
  id,
  label,
  value,
  onChange,
  disabled,
  placeholder = '#000000',
}) {
  const normalized = normalizeHexColor(value);
  const pickerValue = hexForColorInput(normalized || placeholder, placeholder);

  return (
    <div>
      {label ? (
        <label htmlFor={id} className="text-xs font-medium text-foreground mb-1 block">
          {label}
        </label>
      ) : null}
      <div className="flex items-center gap-2">
        <input
          id={id}
          type="color"
          className="h-10 w-12 rounded-md border border-input bg-background p-1 shrink-0 disabled:opacity-50"
          value={pickerValue}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          aria-label={label || 'Couleur'}
        />
        <input
          type="text"
          autoComplete="off"
          spellCheck={false}
          className="min-w-0 flex-1 rounded-md border border-input bg-background px-2 py-2 text-xs font-mono focus:outline-none focus:ring-2 focus:ring-ring disabled:opacity-50"
          value={value ?? ''}
          disabled={disabled}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
}
